<template>
  <div>
    <Modal
      v-model="show"
      :title="(type == 1 ? $t('Info.homeContactUs'):type == 2 ? $t('Info.user_agreement'):type == 3 ? $t('Info.privacy_policy'):type == 4 ? $t('Info.condition'): type == 5 ? $t('Info.contactUs'): type == 6 ? $t('Info.description'): type == 8 ? $t('concept'):$t('Info.keywords'))+$t('edit')"
      :mask-closable="false"
      width="1000"
      @on-cancel="cancel()"
    >
      <div class="modal">
        <Form ref="form" :model="form" :rules="ruleInline" inline :label-width="90" label-colon>
          <Tabs :value="tabs" @on-click="ontabs">
            <TabPane :label="$t('Langue.zn')" name="1">
              <div class="item" v-if="type == 1">
                <!-- <FormItem prop="zh-cn_about_us_address" :label="$t('addrs')"> -->
                <FormItem :label="$t('addrs')">
                  <Input type="text" v-model="form['zh-cn_about_us_address']" placeholder="请输入地址"></Input>
                </FormItem>
                <!-- <FormItem prop="zh-cn_about_us_email" :label="$t('email')"> -->
                <FormItem :label="$t('email')">
                  <Input type="text" v-model="form['zh-cn_about_us_email']" placeholder="请输入邮箱"></Input>
                </FormItem>
                <!-- <FormItem prop="zh-cn_about_us_hotline" :label="$t('hotline')"> -->
                <FormItem :label="$t('hotline')">
                  <Input type="text" v-model="form['zh-cn_about_us_hotline']" placeholder="请输入热线"></Input>
                </FormItem>
                <!-- <FormItem prop="zh-cn_about_us_fax" :label="$t('fax')"> -->
                <FormItem :label="$t('fax')">
                  <Input type="text" v-model="form['zh-cn_about_us_fax']" placeholder="请输入传真"></Input>
                </FormItem>
              </div>
              <div class="item" v-if="type == 2">
                <FormItem prop="zh-cn_user_agreement" :label="$t('content')">
                  <vue-editor
                    v-model="form['zh-cn_user_agreement']"
                    placeholder="请输入用户协议内容"
                    :editor-toolbar="customToolbar"
                    :useCustomImageHandler="true"
                  />
                </FormItem>
              </div>
              <div class="item" v-if="type == 3">
                <FormItem prop="zh-cn_base_private_privacy" :label="$t('content')">
                  <vue-editor
                    v-model="form['zh-cn_base_private_privacy']"
                    placeholder="请输入隐私策略内容"
                    :editor-toolbar="customToolbar"
                    :useCustomImageHandler="true"
                  />
                </FormItem>
              </div>
              <div class="item" v-if="type == 4">
                <FormItem prop="zh-cn_base_tnc" :label="$t('content')">
                  <!-- <FormItem prop="zh-cn_terms_of_use" :label="$t('content')"> -->
                  <!-- <vue-editor
                    v-model="form['zh-cn_terms_of_use']"
                    placeholder="请输入使用条款内容"
                    :editor-toolbar="customToolbar"
                    :useCustomImageHandler="true"
                  />-->
                  <vue-editor
                    v-model="form['zh-cn_base_tnc']"
                    placeholder="请输入使用条款内容"
                    :editor-toolbar="customToolbar"
                    :useCustomImageHandler="true"
                  />
                </FormItem>
              </div>
              <div class="item" v-if="type == 5">
                <FormItem prop="zh-cn_about_us" :label="$t('content')">
                  <vue-editor
                    v-model="form['zh-cn_about_us']"
                    placeholder="请输入联系我们内容"
                    :editor-toolbar="customToolbar"
                    :useCustomImageHandler="true"
                  />
                </FormItem>
              </div>
              <div class="item" v-if="type == 6">
                <FormItem prop="zh-cn_meta_desription" :label="$t('content')">
                  <Input
                    v-model="form['zh-cn_meta_desription']"
                    type="textarea"
                    :autosize="{ minRows: 15, maxRows: 15 }"
                    maxlength="250"
                    show-word-limit
                    placeholder="请输入内容"
                  />
                </FormItem>
              </div>
              <div class="item" v-if="type == 7">
                <FormItem prop="zh-cn_meta_key_words" :label="$t('content')">
                  <Input
                    v-model="form['zh-cn_meta_key_words']"
                    type="textarea"
                    :autosize="{ minRows: 4, maxRows: 4 }"
                    placeholder="请输入内容"
                  />
                </FormItem>
                <div class="photo_tip">{{$t('Info.keywords_hint')}}</div>
              </div>
              <div class="item" v-if="type == 8">
                <FormItem prop="zh-cn_agreement" :label="$t('content')">
                  <vue-editor
                    v-model="form['zh-cn_agreement']"
                    placeholder="Please enter the content"
                    :editor-toolbar="customToolbar"
                    :useCustomImageHandler="true"
                  />
                </FormItem>
              </div>
            </TabPane>
            <TabPane :label="$t('Langue.tw')" name="2">
              <div class="item" v-if="type == 1">
                <!-- <FormItem prop="zh-tw_about_us_address" :label="$t('addrs')"> -->
                <FormItem :label="$t('addrs')">
                  <Input type="text" v-model="form['zh-tw_about_us_address']" placeholder="請輸入地址"></Input>
                </FormItem>
                <!-- <FormItem prop="zh-tw_about_us_email" :label="$t('email')"> -->
                <FormItem :label="$t('email')">
                  <Input type="text" v-model="form['zh-tw_about_us_email']" placeholder="請輸入郵箱"></Input>
                </FormItem>
                <!-- <FormItem prop="zh-tw_about_us_hotline" :label="$t('hotline')"> -->
                <FormItem :label="$t('hotline')">
                  <Input type="text" v-model="form['zh-tw_about_us_hotline']" placeholder="請輸入熱線"></Input>
                </FormItem>
                <!-- <FormItem prop="zh-tw_about_us_fax" :label="$t('fax')"> -->
                <FormItem :label="$t('fax')">
                  <Input type="text" v-model="form['zh-tw_about_us_fax']" placeholder="請輸入傳真"></Input>
                </FormItem>
              </div>
              <div class="item" v-if="type == 2">
                <FormItem prop="zh-tw_user_agreement" :label="$t('content')">
                  <vue-editor
                    v-model="form['zh-tw_user_agreement']"
                    placeholder="請輸入用戶協議內容"
                    :editor-toolbar="customToolbar"
                    :useCustomImageHandler="true"
                  />
                </FormItem>
              </div>
              <div class="item" v-if="type == 3">
                <FormItem prop="zh-tw_base_private_privacy" :label="$t('content')">
                  <vue-editor
                    v-model="form['zh-tw_base_private_privacy']"
                    placeholder="請輸入隱私策略內容"
                    :editor-toolbar="customToolbar"
                    :useCustomImageHandler="true"
                  />
                </FormItem>
              </div>
              <div class="item" v-if="type == 4">
                <!-- <FormItem prop="zh-tw_terms_of_use" :label="$t('content')"> -->
                <FormItem prop="zh-tw_base_tnc" :label="$t('content')">
                  <vue-editor
                    v-model="form['zh-tw_base_tnc']"
                    placeholder="請輸入使用條款內容"
                    :editor-toolbar="customToolbar"
                    :useCustomImageHandler="true"
                  />
                  <!-- <vue-editor
                    v-model="form['zh-tw_terms_of_use']"
                    placeholder="請輸入使用條款內容"
                   :editor-toolbar="customToolbar"
                   :useCustomImageHandler="true"
                  />-->
                </FormItem>
              </div>
              <div class="item" v-if="type == 5">
                <FormItem prop="zh-tw_about_us" :label="$t('content')">
                  <vue-editor
                    v-model="form['zh-tw_about_us']"
                    placeholder="請輸入聯繫我們內容"
                    :editor-toolbar="customToolbar"
                    :useCustomImageHandler="true"
                  />
                </FormItem>
              </div>
              <div class="item" v-if="type == 6">
                <FormItem prop="zh-tw_meta_desription" :label="$t('content')">
                  <Input
                    v-model="form['zh-tw_meta_desription']"
                    type="textarea"
                    :autosize="{ minRows: 15, maxRows: 15 }"
                    maxlength="250"
                    show-word-limit
                    placeholder="請輸入內容"
                  />
                </FormItem>
              </div>
              <div class="item" v-if="type == 7">
                <FormItem prop="zh-tw_meta_key_words " :label="$t('content')">
                  <Input
                    v-model="form['zh-tw_meta_key_words']"
                    type="textarea"
                    :autosize="{ minRows: 4, maxRows: 4 }"
                    placeholder="請輸入內容"
                  />
                </FormItem>
                <div class="photo_tip">{{$t('Info.keywords_hint')}}</div>
              </div>
              <div class="item" v-if="type == 8">
                <FormItem prop="zh-tw_agreement" :label="$t('content')">
                  <vue-editor
                    v-model="form['zh-tw_agreement']"
                    placeholder="Please enter the content"
                    :editor-toolbar="customToolbar"
                    :useCustomImageHandler="true"
                  />
                </FormItem>
              </div>
            </TabPane>
            <TabPane :label="$t('Langue.en')" name="3">
              <div class="item" v-if="type == 1">
                <!-- <FormItem prop="en_about_us_address" :label="$t('addrs')"> -->
                <FormItem :label="$t('addrs')">
                  <Input
                    type="text"
                    v-model="form.en_about_us_address"
                    placeholder="Please enter your address"
                  ></Input>
                </FormItem>
                <!-- <FormItem prop="en_about_us_email" :label="$t('email')"> -->
                <FormItem :label="$t('email')">
                  <Input
                    type="text"
                    v-model="form.en_about_us_email"
                    placeholder="Please enter email address"
                  ></Input>
                </FormItem>
                <!-- <FormItem prop="en_about_us_hotline" :label="$t('hotline')"> -->
                <FormItem :label="$t('hotline')">
                  <Input
                    type="text"
                    v-model="form.en_about_us_hotline"
                    placeholder="Please enter the hotline"
                  ></Input>
                </FormItem>
                <!-- <FormItem prop="en_about_us_fax" :label="$t('fax')"> -->
                <FormItem :label="$t('fax')">
                  <Input
                    type="text"
                    v-model="form.en_about_us_fax"
                    placeholder="Please enter a fax"
                  ></Input>
                </FormItem>
              </div>
              <div class="item" v-if="type == 2">
                <FormItem prop="en_user_agreement" :label="$t('content')">
                  <vue-editor
                    v-model="form.en_user_agreement"
                    placeholder="Please enter user agreement content"
                    :editor-toolbar="customToolbar"
                    :useCustomImageHandler="true"
                  />
                </FormItem>
              </div>
              <div class="item" v-if="type == 3">
                <FormItem prop="en_base_private_privacy" :label="$t('content')">
                  <vue-editor
                    v-model="form.en_base_private_privacy"
                    placeholder="Please enter the privacy policy content"
                    :editor-toolbar="customToolbar"
                    :useCustomImageHandler="true"
                  />
                </FormItem>
              </div>
              <div class="item" v-if="type == 4">
                <!-- <FormItem prop="en_terms_of_use" :label="$t('content')"> -->
                <FormItem prop="en_base_tnc" :label="$t('content')">
                  <!-- <vue-editor
                    v-model="form.en_terms_of_use"
                    placeholder="Please enter the terms of use"
                    :editor-toolbar="customToolbar"
                    :useCustomImageHandler="true"
                  />-->
                  <vue-editor
                    v-model="form.en_base_tnc"
                    placeholder="Please enter the terms of use"
                    :editor-toolbar="customToolbar"
                    :useCustomImageHandler="true"
                  />
                </FormItem>
              </div>
              <div class="item" v-if="type == 5">
                <FormItem prop="en_about_us" :label="$t('content')">
                  <vue-editor
                    v-model="form.en_about_us"
                    placeholder="Please enter contact us content"
                    :editor-toolbar="customToolbar"
                    :useCustomImageHandler="true"
                  />
                </FormItem>
              </div>
              <div class="item" v-if="type == 6">
                <FormItem prop="en_meta_desription" :label="$t('content')">
                  <Input
                    v-model="form.en_meta_desription"
                    type="textarea"
                    :autosize="{ minRows: 15, maxRows: 15 }"
                    maxlength="250"
                    show-word-limit
                    placeholder="Please enter the content"
                  />
                </FormItem>
              </div>
              <div class="item" v-if="type == 7">
                <FormItem prop="en_meta_key_words" :label="$t('content')">
                  <Input
                    v-model="form.en_meta_key_words"
                    type="textarea"
                    :autosize="{ minRows: 4, maxRows: 4 }"
                    placeholder="Please enter the content"
                  />
                </FormItem>
                <div class="photo_tip">{{$t('Info.keywords_hint')}}</div>
              </div>
              <div class="item" v-if="type == 8">
                <FormItem prop="en_agreement" :label="$t('content')">
                  <vue-editor
                    v-model="form.en_agreement"
                    placeholder="Please enter the content"
                    :editor-toolbar="customToolbar"
                    :useCustomImageHandler="true"

                  />
                </FormItem>
              </div>
            </TabPane>
          </Tabs>
        </Form>
      </div>
      <div slot="footer">
        <Button @click="cancel()">{{ $t("cancel") }}</Button>
        <Button type="primary" :loading="loading" @click="submit('form')">{{ $t("sure") }}</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { VueEditor } from 'vue2-editor'
export default {
  components: {
    VueEditor
  },
  props: {
    modal: {
      type: Boolean,
      default: false,
    },
    contactUsObj: String,
    type: Number,
  },

  data () {
    return {
      tabs: '1',
      form: {
        en_about_us_address: "",
        en_about_us_email: "",
        en_about_us_fax: "",
        en_about_us_hotline: "",
        en_base_private_privacy: "",
        en_user_agreement: "",
        "zh-cn_about_us_address": "",
        "zh-cn_about_us_email": "",
        "zh-cn_about_us_fax": "",
        "zh-cn_about_us_hotline": "",
        "zh-cn_base_private_privacy": "",
        "zh-cn_user_agreement": "",
        "zh-tw_about_us_address": "",
        "zh-tw_about_us_email": "",
        "zh-tw_about_us_fax": "",
        "zh-tw_about_us_hotline": "",
        "zh-tw_base_private_privacy": "",
        "zh-tw_user_agreement": "",
        "zh-tw_terms_of_use": "",
        "zh-cn_terms_of_use": "",
        en_terms_of_use: "",
        "zh-cn_base_tnc": "",
        "zh-tw_base_tnc": "",
        en_base_tnc: "",
        "zh-cn_meta_key_words": "",
        "zh-tw_meta_key_words": "",
        en_meta_key_words: "",
        "zh-cn_agreement": "",
        "zh-tw_agreement": "",
        en_agreement: "",
      },
      ruleInline: {
        'zh-cn_about_us_address': [
          {
            required: true,
            message: this.$t('addressInput'),
            trigger: "blur"
          }
        ],
        'zh-cn_about_us_email': [
          {
            required: true,
            message: this.$t('emailInput'),
            trigger: "blur"
          }
        ],
        'zh-cn_about_us_fax': [
          {
            required: true,
            message: this.$t('faxInput'),
            trigger: "blur"
          }
        ],
        'zh-cn_about_us_hotline': [
          {
            required: true,
            message: this.$t('hotlineInput'),
            trigger: "blur"
          }
        ],
        'zh-cn_base_private_privacy': [
          {
            required: true,
            message: this.$t('privatePrivacy'),
            trigger: "blur"
          }
        ],
        'zh-cn_user_agreement': [
          {
            required: true,
            message: this.$t('userAgreementInput'),
            trigger: "blur"
          }
        ],
        'zh-cn_terms_of_use': [
          {
            required: true,
            message: this.$t('termsUse'),
            trigger: "blur"
          }
        ],
        'zh-cn_about_us': [
          {
            required: true,
            message: this.$t('Info.contactUsInput'),
            trigger: "blur"
          }
        ],
        'zh-tw_about_us_address': [
          {
            required: true,
            message: this.$t('addressInput'),
            trigger: "blur"
          }
        ],
        'zh-tw_about_us_email': [
          {
            required: true,
            message: this.$t('emailInput'),
            trigger: "blur"
          }
        ],
        'zh-tw_about_us_fax': [
          {
            required: true,
            message: this.$t('faxInput'),
            trigger: "blur"
          }
        ],
        'zh-tw_about_us_hotline': [
          {
            required: true,
            message: this.$t('hotlineInput'),
            trigger: "blur"
          }
        ],
        'zh-tw_base_private_privacy': [
          {
            required: true,
            message: this.$t('privatePrivacy'),
            trigger: "blur"
          }
        ],
        'zh-tw_user_agreement': [
          {
            required: true,
            message: this.$t('userAgreementInput'),
            trigger: "blur"
          }
        ],
        'zh-tw_terms_of_use': [
          {
            required: true,
            message: this.$t('termsUse'),
            trigger: "blur"
          }
        ],
        'zh-tw_about_us': [
          {
            required: true,
            message: this.$t('Info.contactUsInput'),
            trigger: "blur"
          }
        ],
        en_about_us_address: [
          {
            required: true,
            message: this.$t('addressInput'),
            trigger: "blur"
          }
        ],
        en_about_us_email: [
          {
            required: true,
            message: this.$t('emailInput'),
            trigger: "blur"
          }
        ],
        en_about_us_fax: [
          {
            required: true,
            message: this.$t('faxInput'),
            trigger: "blur"
          }
        ],
        en_base_private_privacy: [
          {
            required: true,
            message: this.$t('privatePrivacy'),
            trigger: "blur"
          }
        ],
        en_user_agreement: [
          {
            required: true,
            message: this.$t('userAgreementInput'),
            trigger: "blur"
          }
        ],
        en_terms_of_use: [
          {
            required: true,
            message: this.$t('termsUse'),
            trigger: "blur"
          }
        ],
        en_about_us: [
          {
            required: true,
            message: this.$t('Info.contactUsInput'),
            trigger: "blur"
          }
        ],
        en_base_tnc: [
          {
            required: true,
            message: this.$t('termsUse'),
            trigger: "blur"
          }
        ],
        "zh-tw_base_tnc": [
          {
            required: true,
            message: this.$t('termsUse'),
            trigger: "blur"
          }
        ],
        "zh-cn_base_tnc": [
          {
            required: true,
            message: this.$t('termsUse'),
            trigger: "blur"
          }
        ],
        en_meta_desription: [
          {
            required: true,
            message: this.$t('content_input'),
            trigger: "blur"
          }
        ],
        "zh-cn_meta_desription": [
          {
            required: true,
            message: this.$t('content_input'),
            trigger: "blur"
          }
        ],
        "zh-tw_meta_desription": [
          {
            required: true,
            message: this.$t('content_input'),
            trigger: "blur"
          }
        ],
        en_meta_key_words: [
          {
            required: true,
            message: this.$t('content_input'),
            trigger: "blur"
          }
        ],
        "zh-cn_meta_key_words": [
          {
            required: true,
            message: this.$t('content_input'),
            trigger: "blur"
          }
        ],
        "zh-tw_meta_key_words": [
          {
            required: true,
            message: this.$t('content_input'),
            trigger: "blur"
          }
        ],
        en_agreement: [
          {
            required: true,
            message: this.$t('content_input'),
            trigger: "blur"
          }
        ],
        "zh-cn_agreement": [
          {
            required: true,
            message: this.$t('content_input'),
            trigger: "blur"
          }
        ],
        "zh-tw_agreement": [
          {
            required: true,
            message: this.$t('content_input'),
            trigger: "blur"
          }
        ],
      },
      customToolbar: [
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        // [{ 'size': ['small', false, 'large', 'huge'] }],
        ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
        [{ 'align': ['', 'center', 'right', 'justify'] }],
        ['blockquote'],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        [{ 'script': 'sub' }, { 'script': 'super' }],      // superscript/subscript
        [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent
        [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
        ['link', 'clean'],                                // remove formatting button
      ],
      loading: false,
      show: this.modal
    }

  },
  created () {

  },
  mounted () {
    this.form = JSON.parse(this.contactUsObj)
  },
  methods: {
    cancel () {
      this.$emit('cancel');
    },
    error () {
      this.$Message.error(this.$t("improve_information"));
    },
    ontabs (item) {
      this.tabs = item
    },
    submit (name) {
      this.loading = true
      this.$refs[name].validate(valid => {
        if (valid) {
          this.$emit('ok', this.form);
          this.cancel()
        } else {
          this.error()
        }
        this.loading = false
      });

    },
  }
}
</script>

<style lang="less" scoped>
/deep/ .modal {
  .item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 80%;
    margin: 20px 0 20px 10%;
  }
  .ivu-tabs-nav-scroll {
    display: flex;
    justify-content: center;
  }

  .ql-editor {
    height: 500px;
  }

  .photo_tip {
    padding-left: 90px;
    color: #c5c8ce;
    font-size: 13px;

  }
}
</style>



// WEBPACK FOOTER //
// src/pages/edu/info/module/contactUs_edit.vue